var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricSelectionOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8H1.75C1.19772 8 0.75 8.44772 0.75 9V14C0.75 14.5523 1.19772 15 1.75 15H3.75C4.30228 15 4.75 14.5523 4.75 14V9C4.75 8.44772 4.30228 8 3.75 8Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.5H1.75C1.47386 8.5 1.25 8.72386 1.25 9V14C1.25 14.2761 1.47386 14.5 1.75 14.5H3.75C4.02614 14.5 4.25 14.2761 4.25 14V9C4.25 8.72386 4.02614 8.5 3.75 8.5Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4H6.75C6.19772 4 5.75 4.44772 5.75 5V14C5.75 14.5523 6.19772 15 6.75 15H8.75C9.30228 15 9.75 14.5523 9.75 14V5C9.75 4.44772 9.30228 4 8.75 4Z",
    fill: "#272D55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 4.5H6.75C6.47386 4.5 6.25 4.72386 6.25 5V14C6.25 14.2761 6.47386 14.5 6.75 14.5H8.75C9.02614 14.5 9.25 14.2761 9.25 14V5C9.25 4.72386 9.02614 4.5 8.75 4.5Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0H11.75C11.1977 0 10.75 0.447715 10.75 1V14C10.75 14.5523 11.1977 15 11.75 15H13.75C14.3023 15 14.75 14.5523 14.75 14V1C14.75 0.447715 14.3023 0 13.75 0Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0.5H11.75C11.4739 0.5 11.25 0.723858 11.25 1V14C11.25 14.2761 11.4739 14.5 11.75 14.5H13.75C14.0261 14.5 14.25 14.2761 14.25 14V1C14.25 0.723858 14.0261 0.5 13.75 0.5Z",
    stroke: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricSelectionOperationIcon);
export default __webpack_public_path__ + "static/media/MetricSelectionOperationIcon.b57858a36a71fb7f63bf8c2f37f98c99.svg";
export { ForwardRef as ReactComponent };